import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var RefreshCcw = createReactComponent("RefreshCcw", ["svg", defaultAttributes, [["path", {
  d: "M3 2v6h6",
  key: "1hhjly"
}], ["path", {
  d: "M21 12A9 9 0 006 5.3L3 8",
  key: "1xl0ej"
}], ["path", {
  d: "M21 22v-6h-6",
  key: "1g0k1o"
}], ["path", {
  d: "M3 12a9 9 0 0015 6.7l3-2.7",
  key: "ixk1tr"
}]]]);
export default RefreshCcw;